import axios from "axios";
import { BASE_URL } from "../config/config";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // 🔥 VERY IMPORTANT
});


axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      sessionStorage.getItem("token") ||
      localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
